/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running a complete 20-minute HIIT session including work and rest intervals.`)
};

const es_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizar una sesión completa de HIIT de 20 minutos, incluyendo intervalos de trabajo y descanso.`)
};

const de_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine komplette 20-minütige HIIT-Session mit Belastungs- und Erholungsintervallen absolvieren.`)
};

const nl_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een volledige HIIT-sessie van 20 minuten draaien inclusief werk- en rustintervallen.`)
};

const fr_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réaliser une session HIIT complète de 20 minutes incluant intervalles d’effort et de repos.`)
};

const it_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eseguire una sessione HIIT completa di 20 minuti con intervalli di lavoro e riposo.`)
};

const pt_br2_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma sessão completa de HIIT de 20 minutos, incluindo intervalos de exercício e descanso.`)
};

const pt_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma sessão completa de HIIT de 20 minutos, incluindo intervalos de exercício e descanso.`)
};

const ja_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業と休憩のインターバルを含む完全な20分間のHIITセッションを行う。`)
};

const zh_timer_u20m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行一次完整的20分钟高强度间歇训练，包含运动和休息间歇。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u20m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u20m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u20m_use3", locale)
	if (locale === "en") return en_timer_u20m_use3(inputs)
	if (locale === "es") return es_timer_u20m_use3(inputs)
	if (locale === "de") return de_timer_u20m_use3(inputs)
	if (locale === "nl") return nl_timer_u20m_use3(inputs)
	if (locale === "fr") return fr_timer_u20m_use3(inputs)
	if (locale === "it") return it_timer_u20m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u20m_use3(inputs)
	if (locale === "pt") return pt_timer_u20m_use3(inputs)
	if (locale === "ja") return ja_timer_u20m_use3(inputs)
	return zh_timer_u20m_use3(inputs)
};